module.exports = __webpack_public_path__ + "img/website1.7cc567bb.png";